var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.94,
    height: 63.8,
    viewBox: "0 0 129.94 63.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006027;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-277 -651.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M343.17,664.65h-2.39a2,2,0,0,0,0,4h.39l-.01,16.17a2,2,0,0,0,2,2h0a2,2,0,0,0,2-2l.01-18.17a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M404.95,688.24H364.97V653.8a2.006,2.006,0,0,0-2-2H320.99a2.006,2.006,0,0,0-2,2v17.7H279a2.006,2.006,0,0,0-2,2v40.1a2.006,2.006,0,0,0,2,2H404.94a2.006,2.006,0,0,0,2-2V690.24A1.985,1.985,0,0,0,404.95,688.24ZM281,675.5h37.98v36.1H281Zm41.98-2V655.8h37.98v55.79H322.98Zm79.97,38.1H364.97V692.24h37.98Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.5d3e6e4956e2d5deff628e47a01065e9.svg";
export { ForwardRef as ReactComponent };